export default "/assets/modules/images/Recommendation-Title.svg?94b342f9d61b92dbbff99e99aa26c864";